import React from "react";

const GameChanger = () => {
  return (
    <div className="my-40 text-[#282d35]">
      <div className="text-center">
        <div className="text-lg font-bold">{"Here's"} the game changer</div>
        <div className="mt-16 text-5xl font-semibold leading-tight">
          <span className="font-extrabold">
            More than 250,000 Mechanical Contracting companies
          </span>{" "}
          in the USA are using pen and paper today because other technologies
          are too complicated
        </div>
        <div className="font-semibold leading-loose mt-14">
          Say goodbye to outdated methods! Invest in EasyDuct App now and
          experience the freedom of effortless takeoff and error-free ordering.
          Join the revolution and empower Mechanical Contractors everywhere to
          break free from the constraints of pen and paper and revolutionize the
          industry with EasyDuct App!
        </div>
      </div>
    </div>
  );
};

export default GameChanger;
